import { render, staticRenderFns } from "./PaymentMethodSelected.vue?vue&type=template&id=3234df19&scoped=true&"
import script from "./PaymentMethodSelected.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSelected.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodSelected.vue?vue&type=style&index=0&id=3234df19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234df19",
  null
  
)

export default component.exports
import {QBtnDropdown,QSeparator,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnDropdown,QSeparator,QIcon,QBtn})
